/** When your routing table is too long, you can split it into small modules**/


export default [{
  path: '/messages',
  name: 'Messages',
  component: () => import('@/views/messages/Index'),

  children: [
    {
      path: 'view',
      component: () => import('@/views/messages/Detail'),

    }
  ], 

}
]
